import { render, staticRenderFns } from "./mp4.vue?vue&type=template&id=0679ee48&scoped=true"
import script from "./mp4.vue?vue&type=script&lang=js"
export * from "./mp4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0679ee48",
  null
  
)

export default component.exports